var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#1E6EF4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.02709 8.69717C4.88745 8.69717 4.74781 8.64393 4.64134 8.53746L2.12374 6.01964C1.91058 5.80669 1.91058 5.46131 2.12374 5.24837C2.33669 5.0352 2.68229 5.0352 2.89501 5.24837L5.02687 7.38022L8.75647 3.65084C8.96941 3.43768 9.31501 3.43768 9.52774 3.65084C9.7409 3.86378 9.7409 4.20917 9.52774 4.42211L5.41261 8.53724C5.30614 8.64371 5.1665 8.69695 5.02687 8.69695L5.02709 8.69717Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCheck);
export default __webpack_public_path__ + "static/media/daily_check.baf9b62890197baf2cd3ec077d5b03c9.svg";
export { ForwardRef as ReactComponent };